<section class="relative grow z1" (keydown.esc)="closeOptionsList(true)" (focusout)="handleComponentFocusOut($event)">
  <div
    role="status"
    id="to-field-listbox-label"
    class="is-vishidden"
    [hidden]="!(inputHasFocus || (optionsListVisible$ | async))"
  >
    {{
      'destinationSearch.selectableDestinations' | finLocalization: { amount: (matchingDestinations$ | async)?.length }
    }}
  </div>
  <div
    class="input relative white-bg rounded-medium border shadow-small grow"
    [class.input--focused]="inputHasFocus"
    [class.input--has-query]="inputField.value"
    [class.z5]="optionsListVisible$ | async"
    (click)="onClickInputArea($event)"
  >
    <label
      for="to-field-combobox"
      aria-hidden="true"
      class="input-label block z2 absolute nordic-blue-900-text regular-type ps-small-l font-body-1"
    >
      <ng-container>
        {{
          selectedDestinations?.length
            ? ('destinationSearch.toInputLabelMoreDestinations' | finLocalization)
            : ('destinationSearch.toInputLabel' | finLocalization)
        }}
      </ng-container>
    </label>
    <input
      type="text"
      role="combobox"
      id="to-field-combobox"
      [attr.aria-expanded]="optionsListVisible$ | async"
      [attr.aria-activedescendant]="
        (highlightedItem$ | async) > -1 ? 'to-field-option-' + (highlightedItem$ | async) : null
      "
      aria-autocomplete="list"
      aria-controls="to-field-listbox"
      aria-owns="to-field-listbox"
      aria-haspopup="listbox"
      autocomplete="off"
      [formControl]="destinationInput"
      class="fill no-outline absolute block border-none rounded-medium ps-small-l font-body-1 regular-type"
      (keydown)="onDestinationInputKeydown($event)"
      #inputField
    />
    <button
      class="input-icon block absolute"
      tabindex="-1"
      [attr.aria-expanded]="optionsListVisible$ | async"
      aria-controls="to-field-listbox"
      data-testid="destination-search-to-input-button"
      #inputFieldButton
    >
      <span class="is-vishidden">{{
        (optionsListVisible$ | async)
          ? ('destinationSearch.hideSelectableDestinations' | finLocalization)
          : ('destinationSearch.showSelectableDestinations' | finLocalization)
      }}</span>
      <fcom-icon
        *ngIf="(optionsListVisible$ | async) === false"
        class="icon-medium"
        [name]="SvgLibraryIcon.SEARCH"
      ></fcom-icon>
      <fcom-icon
        *ngIf="optionsListVisible$ | async"
        class="icon-medium"
        [name]="SvgLibraryIcon.CLOSE_DELETE"
      ></fcom-icon>
    </button>
  </div>

  <div
    class="options z5 absolute white-bg shadow ms-xsmall-t"
    [hidden]="(optionsListVisible$ | async) === false"
    data-testid="destinations-search-filter-options-list-container"
  >
    <ul
      role="listbox"
      aria-labelledby="to-field-listbox-label"
      aria-multiselectable="true"
      id="to-field-listbox"
      class="no-list-style relative listbox"
      tabindex="-1"
      #optionsListbox
    >
      <li
        role="option"
        [id]="'to-field-option-' + i"
        [attr.aria-selected]="destinationIsSelected(destination) ? 'true' : 'false'"
        *ngFor="let destination of matchingDestinations$ | async; index as i"
        [class.highlighted]="destinationIsHighlighted(i)"
        (click)="toggleDestinationSelection(destination)"
        class="ps-medium-x"
      >
        <div
          class="border-bottom ps-small-y"
          [class.bold-type]="
            destination.type === DESTINATION_TYPE.CONTINENT || destination.type === DESTINATION_TYPE.COUNTRY
          "
          [class.ps-small-l]="destination.type === DESTINATION_TYPE.COUNTRY"
          [class.ps-large-l]="destination.type === DESTINATION_TYPE.DESTINATION"
        >
          <span
            [class.nordic-blue-900-text]="destinationIsSelected(destination)"
            [class.nordic-blue-900-text]="!destinationIsSelected(destination)"
          >
            {{ destination.title }}
          </span>
          <fcom-icon
            *ngIf="destinationIsSelected(destination)"
            class="inline-block float-right heather-700-text icon-medium list-check"
            [name]="SvgLibraryIcon.CHECKMARK"
          ></fcom-icon>
        </div>
      </li>
      <li *ngIf="!(matchingDestinations$ | async)?.length" class="ps-medium-x inactive">
        <div class="border-bottom ps-small-y">
          <span>
            {{ 'destinationSearch.noMatches' | finLocalization }}
          </span>
        </div>
      </li>
    </ul>

    <div class="pr-xsmall nordic-blue-50-bg flex flex--row-reverse">
      <fcom-button
        class="ps-medium-l show-results-button"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [text]="'destinationSearch.show' | finLocalization"
        (clickBtn)="closeOptionsList()"
        #showResultsButton
      ></fcom-button>
      <div class="flex-4" *ngIf="selectedDestinations?.length">
        <div class="font-body-1 regular-type ps-small-b">{{ 'destinationSearch.flightsTo' | finLocalization }}</div>
        <ul class="selections no-list-style flex flex--wrap" #tagList>
          <li *ngFor="let item of selectedDestinations; let i = index" class="ms-xsmall-r ms-xsmall-b">
            <fcom-chip
              id="{{ item.id }}"
              [text]="item.title"
              [title]="('actions.remove' | finLocalization) + ' ' + item.title"
              [iconName]="SvgLibraryIcon.CLOSE_DELETE"
              [theme]="ChipTheme.ACTIVE"
              (tagClicked)="removeTag(item)"
              tabindex="-1"
            >
            </fcom-chip>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="options-bg z4" (click)="closeOptionsList(false)" [hidden]="(optionsListVisible$ | async) === false"></div>
</section>
